import { Fragment, h } from "preact";

export const PRIVACY_POLICY_HEADER = "Data Protection";
export const PRIVACY_POLICY_URL = "/privacy-policy";
export const PRIVACY_POLICY_EXTERNAL_URL = "https://www.greencrosshealth.co.nz/privacy-policy?utm_source=livingrewards&utm_medium=referral";
export const PRIVACY_POLICY_BODY = (
	<Fragment>
		Your personal information is managed in accordance with the<br /><a href={PRIVACY_POLICY_EXTERNAL_URL} target="_blank">Green Cross Health Customer Privacy Policy</a>. 
	</Fragment>
);